import { render, staticRenderFns } from "./JcomZoneBoardMembersAssign.vue?vue&type=template&id=0e9800c2"
import script from "./JcomZoneBoardMembersAssign.vue?vue&type=script&lang=js"
export * from "./JcomZoneBoardMembersAssign.vue?vue&type=script&lang=js"
import style0 from "./JcomZoneBoardMembersAssign.vue?vue&type=style&index=0&id=0e9800c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports